import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { useAuth } from '@/contexts/AuthContext';
import { motion } from 'framer-motion';
import { Lock, ChefHat } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export default function AdminLogin() {
  const { t } = useLanguage();
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && (user.role === 'admin' || user.role === 'superadmin')) {
      navigate('/admin');
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const result = await login(email, password);
    if (result.success) {
      navigate('/admin');
    } else {
      setError(result.error);
    }
    setLoading(false);
  };

  return (
    <div className="pt-20 lg:pt-24 pb-20 min-h-[80vh] flex items-center justify-center" data-testid="admin-login-page">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md mx-4">
        <div className="text-center mb-8">
          <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: '#e53a3a15' }}>
            <ChefHat className="w-8 h-8 text-[#e53a3a]" />
          </div>
          <h1 className="font-heading text-3xl font-bold text-[#1a1a1a]">{t('admin.login')}</h1>
        </div>
        <form onSubmit={handleSubmit} className="bg-white rounded-xl border border-[#e0e0e0] p-8 space-y-5 shadow-sm" data-testid="admin-login-form">
          {error && <div className="p-3 rounded-lg bg-red-50 text-red-700 text-sm" data-testid="login-error">{error}</div>}
          <div>
            <Label>{t('admin.email')}</Label>
            <Input type="email" value={email} onChange={e => setEmail(e.target.value)} required className="mt-1" data-testid="admin-email-input" />
          </div>
          <div>
            <Label>{t('admin.password')}</Label>
            <Input type="password" value={password} onChange={e => setPassword(e.target.value)} required className="mt-1" data-testid="admin-password-input" />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="btn-belgo w-full flex items-center justify-center gap-2 px-6 py-3 rounded-lg text-white font-semibold"
            style={{ backgroundColor: '#e53a3a' }}
            data-testid="admin-login-btn"
          >
            <Lock className="w-4 h-4" /> {loading ? '...' : t('admin.signIn')}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
